import React, { useEffect, useRef, useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import WhPackPrint from '../View/WhPackPrint';
import { CircularProgress } from '@mui/material';
import WhInvoiceBill from '../View/WhInvoiceBill';
import { deleteInvInfo } from '../../../Store/PHPSlice/Packing/PackApis';



const TableBody = ({
    serialNumber,
    id,
    firmNm,
    pkMemo,
    partyNm,
    transport,
    billNo,
    dt,
    totqty,
    sts,
    wsts,
    partyId,
    firmId,
    total_amt,
    net_amt,
    selected,
    handleClick,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const hiddenRef = useRef();
    const [packdata, setPackdata] = useState([]);
    const [packInfo, setPackInfo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [firmUrl, setFirmUrl] = useState('');

    const [readyToPrint, setReadyToPrint] = useState(false);

    useEffect(() => {
        if (
            readyToPrint &&
            packdata?.length > 0 &&
            packInfo?.length > 0
        ) {
            // PDF will auto-generate inside WhPackPrint
            setReadyToPrint(false);
            setLoading(false);
        }
    }, [readyToPrint, packdata, packInfo]);

    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        // window.open(`/packing-edit/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const userId = '1';



    const handleDeleteClick = () => {
        // Show confirmation dialog


        const isConfirmed = window.confirm("Are you sure you want to delete this Invoice Details?");

        // // If user confirms, proceed with deletion
        if (isConfirmed) {
             dispatch(deleteInvInfo(id))
                 .then(() => {
                     // Reload the page to show updated results
                     alert("Invoice Deleted Successfully...!!");
                     window.location.reload();
                 })
                 .catch((error) => {
                     // Handle any errors that occur during the deletion process
                     console.error("Error deleting Item:", error);
                     alert("Failed to delete Invoice");
                 });
        }
    };

    const handleFinalPrint = () => {
        // window.open(`/packing-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    }

    const handleViewClick = () => {
        window.open(`/invoice-bill/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    const handlePendingClick = () => {
        // window.open(`/packing-sale-invoice/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    const handleWhatsAppClick = async () => {
        if (loading) return;

        setLoading(true);

        try {
            // 1. Fetch required data
            await fetchPackingData(id);
            await fetchData(firmId);

            // 2. Wait for React to update state
            setTimeout(() => {
                setReadyToPrint(true);
            }, 300);

        } catch (error) {
            console.error("WhatsApp Error:", error);
            alert("Failed to prepare data");
            setLoading(false);
        }
    };

    const fetchPackingData = async (id) => {
        try {
            const res = await axios.get(
                `${baseUrl}?apicall=getPackingInvoiceRegister&invId=${id}`
            );

            if (res.data) {
                setPackdata(res.data?.data);
                setPackInfo(res?.data?.Info);
            }
        } catch (error) {
            console.error(" error:", error);
            setPackdata([]);
        }
    }

    const fetchData = async (id) => {
        try {
            const res = await axios.get(
                `${baseUrl}?apicall=getFirmHeaderImageBase64&firmId=${id}`
            );

            if (res.data?.status) {
                setFirmUrl(res.data.image);
            }
        } catch (error) {
            console.error("Firm image error:", error);
            setFirmUrl("");
        }
    };


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {billNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {partyNm}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {total_amt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {net_amt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {loading ? <><CircularProgress size="20px" />sending...</> :
                        <WhatsAppIcon
                            onClick={!loading ? handleWhatsAppClick : undefined}
                            style={{
                                color: loading ? "#aaa" : "#25D366",
                                cursor: loading ? "not-allowed" : "pointer",
                                opacity: loading ? 0.6 : 1
                            }}
                        />}

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {wsts === "1" ? (
                        <button
                            style={{
                                backgroundColor: "green",
                                color: "white",
                                padding: "4px 12px",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "default"
                            }}
                        >
                            Sent
                        </button>
                    ) : (
                        <button
                            style={{
                                backgroundColor: "red",
                                color: "white",
                                padding: "4px 12px",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "default"
                            }}
                        >
                            Pending
                        </button>
                    )}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>*/}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={'cursor-pointer'} onClick={handleDeleteClick} />
                </TableCell> 


            </TableRow>


            {/* Hidden printable component */}
            <div style={{ position: "absolute", left: "-9999px" }}>
                <WhInvoiceBill
                    id={id}
                    data={packdata}
                    info={packInfo}
                    partyId={partyId}
                    url={firmUrl}
                    onDone={() => setLoading(false)}
                />
            </div>
        </>
    );
};

export default React.memo(TableBody);
